// extracted by mini-css-extract-plugin
export default {"tasks-list__content":"tasksList_tasks-list__content__RJnBG","tasks-list--disabled":"tasksList_tasks-list--disabled__FDtgN"};